import(/* webpackMode: "eager" */ "/app/app/shipping-policy/page.tsx");
